import { SearchOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Input,
  message,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
} from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { ReactComponent as ArchiveRestore } from "../../Images/ArchiveRestore.svg";
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';

import { fetchArchivedVehicleTypeList, unArchiveVehicleType } from '../../slices/vehicle-type';

function ArchiveVehicleTypeList() {
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [orderBy, setOrderBy] = useState('');

  const dispatch = useDispatch();
  const { data = [], totalRecord = 0, status } = useSelector(state => state.vehicleType || {});
  useEffect(() => {
    dispatch(
      fetchArchivedVehicleTypeList({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }),
    );
  }, [dispatch, page, pagesize, search, orderBy]);

  const handleSearch = e => {
    setSearch(e.target.value);
    setPage(1); // Reset to the first page when searching
  };

  const resetFilter = () => {
    setSearch('');
    setPage(1);
    setOrderBy('');
  };

  const handlePageChange = newPage => {
    setPage(newPage);
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'vehicle_type' && sortOrder === 'ascend') {
      sortingEnumKey = 'vehicle_type';
    }
    if (sortField === 'vehicle_type' && sortOrder === 'descend') {
      sortingEnumKey = '-vehicle_type';
    }
    if (sortField === 'created_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_at';
    }
    if (sortField === 'created_at' && sortOrder === 'descend') {
      sortingEnumKey = '-created_at';
    }
    if (sortField === 'created_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_by';
    }
    if (sortField === 'created_by' && sortOrder === 'descend') {
      sortingEnumKey = '-created_by';
    }
    if (sortField === 'updated_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_at';
    }
    if (sortField === 'updated_at' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_at';
    }
    if (sortField === 'updated_by_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_by__username';
    }
    if (sortField === 'updated_by_name' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_by__username';
    }
    return sortingEnumKey;
  };
  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter && sorter.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
    if (pagination && typeof pagination.pageSize === 'number') {
      setPageSize(pagination.pageSize);
    }
    if (pagination && typeof pagination.current === 'number') {
      setPage(pagination.current);
    }
  };
  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
  }));

  const handleRestore = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }

    dispatch(unArchiveVehicleType(id))
      .unwrap()
      .then(() => {
        message.success('Vehicle type Unarchived Successfully!');
        dispatch(
          fetchArchivedVehicleTypeList({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }),
        );
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: 100,
    },
    {
      title: 'Vehicle Type',
      dataIndex: 'vehicle_type',
      key: 'vehicle_type',
      width: 200,
      sorter: true,
    },
    {
      title: 'Archive At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      sorter: true,
      width: 100,
      render: (record) => {
        return (
          <span>{record ? dayjs(record).format('DD-MM-YYYY HH:mm'): 'N/A'} </span>
        )
      }
    },
    {
      title: 'Archive By',
      dataIndex: 'updated_by_name',
      key: 'updated_by_name',
      width: 100,
      sorter: true,
      render: (record) => {
        return (
          <span>{record ? `${record}` : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Action',
      dataIndex: 'action',
      fixed: 'right',
      width: 100,
      render: (_, record) => (
        <Space>
          <Tooltip placement="top" title="Restore">
            <Popconfirm
              title="Are you sure you want to Unarchive this record?"
              onConfirm={() => handleRestore(record.id)} // Trigger delete on confirmation
              onCancel={() => message.info('Action cancelled')} // Optional cancel action
              okText="Yes"
              cancelText="No"
            >
              <ArchiveRestore className="ArchiverestorImg" />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];


  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  return (
    <>
      <div className='sticyaction'>
        <Row className="pagenamerow" justify="space-between" align="middle">
          <Col>
            <h2 style={{ margin: 0 }}>Archived Vehicle Types</h2>
            <div className="bredcrumbwrp">
              <Link to="/vehicle-type-list" className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/vehicle-type-list">Vehicle Type</Link> },
                  { title: 'Archived Vehicle Type' }
                ]}
              />
            </div>
          </Col>
          <Col>
            <Space size="large">
              <Input
                placeholder="Search"
                  className='searchbox'
                prefix={<SearchOutlined />}
                value={search}
                style={{ width: 200 }}
                onChange={handleSearch}
              />
              <Tooltip placement="top" title={'Reset Filter'}>
                <Button
                  type="primary"
                  disabled={!search && !orderBy}
                  className="iconlink"
                  onClick={resetFilter}
                >
                  <FilterIcon />
                </Button>
              </Tooltip>
            </Space>
          </Col>
        </Row>
      </div>
       <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, overflow: 'auto' }}>
      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey="id"
      
        loading={status === 'loading'}
        pagination={false}
        scroll={{
          x: 180, // Horizontal Scroll
          y: 350,  // Vertical Scroll with Fixed Header
        }}
        onChange={handleTableChange}
        // style={{ marginTop: '20px' }}
      />
        </div>
        <div
          style={{
            position: 'sticky',
            bottom: 0,
            zIndex: 1000,
            background: '#fff',
            padding: 10,
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Pagination
            current={page || 1}
            pageSize={pagesize || 10}
            total={totalRecord || 0}
            showSizeChanger
            pageSizeOptions={["10", "20", "50", "100"]}
            onShowSizeChange={handlePageSizeChange}
            showTotal={total => `Total ${total} items`}
            onChange={handlePageChange}
            locale={{ items_per_page: 'Items / Page' }}
          />
        </div>
      </div>
    </>
  );
}

export default ArchiveVehicleTypeList;
